/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{__decorate as r}from"tslib";import{subclass as o}from"../core/accessorSupport/decorators.js";let s=class{};s=r([o("esri.graphic.GraphicOrigin")],s);export{s as default};
